import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './container/Root';
import reportWebVitals from './reportWebVitals';
import "./assets/fonts/Poppins-Medium.ttf";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-calendar/dist/Calendar.css';
import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "react-datepicker/dist/react-datepicker.css";
import { AuthProvider } from './modules/authContext';
import { toast } from 'react-toastify';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider toastError={toast.error} toastSuccess={toast.success}>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
